import { render } from "./ChapterEdit.vue?vue&type=template&id=3f90d8c4"
import script from "./ChapterEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ChapterEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/chapter/ChapterEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f90d8c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f90d8c4', __exports__)) {
    api.reload('3f90d8c4', __exports__)
  }
  
  module.hot.accept("./ChapterEdit.vue?vue&type=template&id=3f90d8c4", () => {
    api.rerender('3f90d8c4', render)
  })

}


export default __exports__